import {
  AuthorizedUiElementServiceProvider,
  AuthorizedUiElementConfig,
} from "../../../../ui/authorizedUiElement";
import { StateProvider, StateService } from "@uirouter/angularjs";
import { UserProfile } from "../../../../application/UserProfile";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../views/machines/detail/tabs";

export const vsSingleServiceName = "singleMachineChangeChildStateService";
export const vsSingleProviderName = `${vsSingleServiceName}Provider`;

export interface SingleMachineChangeChildStateConfig
  extends AuthorizedUiElementConfig {}

export class SingleMachineChangeChildStateServiceProvider extends AuthorizedUiElementServiceProvider<SingleMachineChangeChildStateConfig> {
  static $inject = ["$stateProvider", MachineDetailTabsProviderName];
  constructor(
    stateProvider: StateProvider,
    private readonly machineDetailTabsProvider: MachineDetailTabsProvider
  ) {
    super(stateProvider);
  }

  override $get = [
    "userProfile",
    "$state",
    (userProfile: UserProfile, $state: StateService) =>
      this.defaultServiceFactory(userProfile, $state),
  ];

  override basePath: string = `${this.machineDetailTabsProvider.basePath}.configurations`;
}
